const PAST_PASSENGER_NUMBER_PLACEHOLDER_PATTERN = /^(0+|n\/?a|none|null|unknown)$/i
const PAST_PASSENGER_NUMBER_ALPHANUMERIC_PATTERN = /^[a-z0-9]+$/i
const MIN_PAST_PASSENGER_NUMBER_LENGTH = 3
const MAX_PAST_PASSENGER_NUMBER_LENGTH = 30

export function isValidPastPassengerNumber(value?: string): boolean {
  const normalizedValue = value?.trim()

  if (!normalizedValue) return true

  return normalizedValue.length >= MIN_PAST_PASSENGER_NUMBER_LENGTH &&
    normalizedValue.length <= MAX_PAST_PASSENGER_NUMBER_LENGTH &&
    PAST_PASSENGER_NUMBER_ALPHANUMERIC_PATTERN.test(normalizedValue) &&
    !PAST_PASSENGER_NUMBER_PLACEHOLDER_PATTERN.test(normalizedValue)
}
